(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bau-bundle-UI"] && !Shopify.designMode) return;
  try {
    
  /**
   * Bundle Builder — Product Grid (Sprint 1)
   *
   * Self-contained UI behaviour only: colour-swatch → image/price swap, and
   * placeholder click logging for buttons that will eventually drive the
   * Bundle Store / drawer / modals in later sprints. No quantity selector and
   * no standalone price on the card — quantity moves to the Bundle Tray, and
   * price only ever lives inside the Add to Bundle button.
   *
   * Nothing here talks to a cart, a drawer, or any bundle state — every
   * "Future:" comment below marks a spot later sprints will hook into.
   */
  (function () {
    var VariantSwatches = {
      init: function (card) {
        var swatchWrap = card.querySelector('.bundle-card__swatches');
        var dataEl = card.querySelector('[data-role="variant-data"]');
        if (!swatchWrap || !dataEl) return;

        var variants;
        try {
          variants = JSON.parse(dataEl.textContent);
        } catch (e) {
          return;
        }

        var swatches = Array.prototype.slice.call(swatchWrap.querySelectorAll('[data-action="select-colour"]'));
        var refs = {
          image: card.querySelector('[data-role="variant-image"]'),
          colourLabel: card.querySelector('[data-role="colour-name"]'),
          ctaBtn: card.querySelector('[data-action="add-to-bundle"]'),
          ctaLabel: card.querySelector('[data-role="cta-label"]'),
          ctaPrice: card.querySelector('[data-role="cta-price"]')
        };

        swatches.forEach(function (swatch) {
          swatch.addEventListener('click', function () {
            var variant = VariantSwatches.findVariant(variants, swatch.getAttribute('data-variant-id'));
            if (!variant) return;

            VariantSwatches.markSelected(swatches, swatch);
            VariantSwatches.applyVariant(card, refs, variant);

            // Future: notify Bundle Store of the newly selected variant for this card.
          });
        });
      },

      findVariant: function (variants, variantId) {
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(variantId)) {
            return variants[i];
          }
        }
        return null;
      },

      markSelected: function (swatches, selected) {
        swatches.forEach(function (s) {
          var isSelected = s === selected;
          s.classList.toggle('is-selected', isSelected);
          s.setAttribute('aria-checked', String(isSelected));
        });
      },

      applyVariant: function (card, refs, variant) {
        if (refs.image && variant.image) {
          refs.image.src = variant.image;
        }

        if (refs.colourLabel) {
          refs.colourLabel.textContent = 'Colour: ' + variant.title;
        }

        if (refs.ctaBtn) {
          refs.ctaBtn.disabled = !variant.available;
          refs.ctaBtn.classList.toggle('is-disabled', !variant.available);
        }

        if (refs.ctaLabel) {
          refs.ctaLabel.textContent = variant.available
            ? (refs.ctaLabel.getAttribute('data-default-label') || refs.ctaLabel.textContent)
            : 'Sold Out';
        }

        // Price lives only inside the CTA button, per the Figma — this is the
        // single place a price swap needs to update.
        if (refs.ctaPrice) {
          refs.ctaPrice.textContent = variant.price;
        }

        card.setAttribute('data-variant-id', variant.id);
        card.classList.toggle('is-sold-out', !variant.available);
      }
    };

    var CardActions = {
      init: function (card) {
        var infoBtn = card.querySelector('[data-action="product-info"]');
        if (infoBtn) {
          infoBtn.addEventListener('click', function () {
            console.log('Product Info clicked', card.getAttribute('data-product-id'));
            // Future: open Product Info modal (out of scope this sprint).
          });
        }

        var addBtn = card.querySelector('[data-action="add-to-bundle"]');
        if (addBtn) {
          addBtn.addEventListener('click', function () {
            console.log('Add to Bundle clicked', {
              productId: card.getAttribute('data-product-id'),
              variantId: card.getAttribute('data-variant-id'),
              blockId: card.getAttribute('data-block-id')
            });
            // Future: dispatch to Bundle Store (out of scope this sprint).
          });
        }
      }
    };

    var PromoTiles = {
      init: function (root) {
        var tiles = root.querySelectorAll('.bundle-promo-tile');
        tiles.forEach(function (tile, index) {
          tile.addEventListener('click', function () {
            var label = tile.querySelector('.bundle-promo-tile__description');
            var text = label ? label.textContent.trim() : 'Promo tile ' + (index + 1);

            if (/compare/i.test(text)) {
              console.log('Compare clicked');
              // Future: open Comparison modal (out of scope this sprint).
            } else if (/size/i.test(text)) {
              console.log('Size Guide clicked');
              // Future: open Size Guide modal (out of scope this sprint).
            } else {
              console.log('Promo tile clicked:', text);
            }
          });
        });
      }
    };

    function initBundleBuilder(root) {
      if (!root || root.dataset.bundleBuilderInit === 'true') return;
      root.dataset.bundleBuilderInit = 'true';

      var cards = root.querySelectorAll('[data-role="bundle-card"]');
      cards.forEach(function (card) {
        VariantSwatches.init(card);
        CardActions.init(card);
      });

      PromoTiles.init(root);
    }

    function initAll() {
      document.querySelectorAll('.bundle-builder').forEach(initBundleBuilder);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.bundle-builder');
      if (section) initBundleBuilder(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-section-design"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    const faqItems = document.querySelectorAll(".faq-item");

    faqItems.forEach((item) => {
      const question = item.querySelector(".faq-question");

      question.addEventListener("click", () => {
        // Close all FAQs first
        faqItems.forEach((faq) => {
          if (faq !== item) {
            faq.classList.remove("open");
            faq.querySelector(".faq-answer").style.display = "none";
          }
        });

        // Toggle current FAQ
        item.classList.toggle("open");
        const answer = item.querySelector(".faq-answer");
        answer.style.display = item.classList.contains("open") ? "block" : "none";
      });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
